import "@shoelace-style/shoelace/dist/components/badge/badge.js";
import React from "react";

/**
 * TaskCardHeader - Header section of a task card
 *
 * @param {Object} props
 * @param {Object} props.task - Task data
 * @param {boolean} props.isEditing - Whether task is in edit mode
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onChange - Change handler for edit mode
 * @param {Object} props.editedTask - Edited task data
 * @param {React.RefObject} props.titleRef - Ref for title input
 */
const TaskCardHeader = ({
  task,
  isEditing,
  onEdit,
  onChange,
  editedTask,
  titleRef,
}) => {
  // Determine badge variant based on status
  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case "Incoming":
        return "primary";
      case "Todo":
        return "warning";
      case "In Progress":
        return "success";
      case "Ideation":
        // Using danger variant for Ideation to get a red color
        return "danger";
      case "Done":
        return "neutral";
      case "Archived":
        return "neutral";
      default:
        return "neutral";
    }
  };

  // Get the appropriate CSS class for the badge
  const getBadgeClass = (status) => {
    return "ml-2 text-xs";
  };

  return (
    <div className="mb-2">
      {isEditing ? (
        <input
          ref={titleRef}
          type="text"
          name="title"
          value={editedTask.title}
          onChange={onChange}
          className="w-full p-1 bg-[#262b30] border border-[#4db1e0] rounded text-white text-sm"
        />
      ) : (
        <div className="flex justify-between items-start">
          <h3
            className="text-white font-medium text-sm cursor-pointer hover:text-[#4db1e0]"
            onClick={onEdit}
          >
            {task.title}
          </h3>
          <sl-badge
            variant={getStatusBadgeVariant(task.status)}
            className={getBadgeClass(task.status)}
          >
            {task.status}
          </sl-badge>
        </div>
      )}
    </div>
  );
};

export default TaskCardHeader;
